module.exports = __webpack_public_path__ + "img/map.e762e231.png";